import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})
export class CadastroService {

  constructor(private http: HttpClient, private util: UtilService) {

  }

  public alterarSenha(dados: any){

    return this.http
                .post(`${environment.apiURL}/Logado/Cadastro/AlterarSenha`, dados);
  }

  public dadosContatoListar(){

    return this.http
                .get(`${environment.apiURL}/Logado/Cadastro/DadosContatoListar`);
  }

  public dadosContatoAlterar(dados: any){

    return this.http
                .put(`${environment.apiURL}/Logado/Cadastro/DadosContatoAlterar`, dados);
  }

  public buscaDadosPessoais(){
    return this.http
               .get(`${environment.apiURL}/Logado/Cadastro/BuscaDadosPessoais`)
  }

  public listaEstadoCivil(){
    return this.http
               .get(`${environment.apiURL}/Logado/Cadastro/ListarEstadoCivil`)
  }

  public listaSexos(){
    return this.http
               .get(`${environment.apiURL}/Logado/Cadastro/ListarSexo`)
  }

  public dadosPessoaisAlterar(form){
    return this.http
               .put(`${environment.apiURL}/Logado/Cadastro/AlteraDadosPessoais`, form)
  }

  public enderecoCarregar(){
    return this.http
               .get(`${environment.apiURL}/Logado/Cadastro/EnderecoCarregar`)
  }

  public enderecoSalvar(form){
    return this.http
               .put(`${environment.apiURL}/Logado/Cadastro/EnderecoSalvar`, form)
  }

  public dadosAssociado(){
    return this.http
               .get(`${environment.apiURL}/Logado/Cadastro/DadosAssociado`)
  }

  public represLegalCarregar(){
    return this.http
               .get(`${environment.apiURL}/Logado/Cadastro/RepresLegalCarregar`)
  }

  public represLegalSalvar(form: any){
    return this.http
               .put(`${environment.apiURL}/Logado/Cadastro/RepresLegalSalvar`, form)
  }

  public listarRepresLegalTipo(){
    return this.http
               .get(`${environment.apiURL}/Logado/Cadastro/ListarRepresLegalTipo`)

  }

  /** Beneficiários **/

  public listarBeneficiario(){
    return this.http
               .get(`${environment.apiURL}/Logado/Cadastro/ListarBeneficiario`)
  }

  public inserirBeneficiario(form){
    return this.http
               .put(`${environment.apiURL}/Logado/Cadastro/InserirBeneficiario`,form)
  }

  public finalizarVigenciaBeneficiario(codPartBenef: number, assinatura: string){

    return this.http
                .put(`${environment.apiURL}/Logado/Cadastro/FinalizarVigenciaBeneficiario?codPartBenef=${codPartBenef}&assinatura=${assinatura}`, {});
  }

  /** Termos **/

  public termosCarregar():Observable<any>{
    return this.http
               .get(`${environment.apiURL}/Logado/Cadastro/TermosCarregar`)

  }

  public termosSalvarNIF(dados):Observable<any>{
    return this.http
               .post(`${environment.apiURL}/Logado/Cadastro/TermosSalvarNIF`, dados);
  }

  public termosExcluirNIF(dados):Observable<any>{
    return this.http
               .post(`${environment.apiURL}/Logado/Cadastro/TermosExcluirNIF`, dados);
  }

  public termosUSPersonAlterar(dados):Observable<any>{
    return this.http
               .put(`${environment.apiURL}/Logado/Cadastro/TermosUsPersonAlterar`, dados)

  }

  public termosPPEAlterar(dados):Observable<any>{
    return this.http
               .put(`${environment.apiURL}/Logado/Cadastro/TermosPPEAlterar`, dados)

  }
}
